import { DisplayValuesMap } from '~/common/types/data';
import { PcfraActivityType } from '~/common/types/pcfra';

export const pcfraActivityDisplayValues: DisplayValuesMap<PcfraActivityType> = {
  'successful-contact': 'Contact with resident',
  'failed-contact': 'Failed contact attempt',
  'self-referral-accepted': 'Self-referral accepted',
  'self-referral-rejected': 'Self-referral rejected',
  'rpeep-completed': 'RPEEP completed',
  'rpeep-revoked': 'RPEEP revoked',
};
